var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000.11 906.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #007aff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Horizontal"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M987.69,361.77h-271.45c-27.97,0-41.97-33.81-22.2-53.59l172.86-172.86c4.85-4.85,4.85-12.71,0-17.56L752.77,3.64c-4.85-4.85-12.71-4.85-17.56,0l-170.85,170.85c-36.48,36.48-36.51,95.59-.1,132.11l95.53,95.53c28.31,28.31,28.31,74.22,0,102.53l-95.53,95.53c-36.41,36.52-36.38,95.64.1,132.11l170.85,170.85c4.85,4.85,12.71,4.85,17.56,0l114.13-114.13c4.85-4.85,4.85-12.71,0-17.56l-172.86-172.86c-19.78-19.78-5.77-53.59,22.2-53.59h271.45c6.86,0,12.42-5.56,12.42-12.42v-158.41c0-6.86-5.56-12.42-12.42-12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.42,361.77h271.45c27.97,0,41.97-33.81,22.2-53.59l-172.86-172.86c-4.85-4.85-4.85-12.71,0-17.56L247.34,3.64c4.85-4.85,12.71-4.85,17.56,0l170.85,170.85c36.48,36.48,36.51,95.59.1,132.11l-95.53,95.53c-28.31,28.31-28.31,74.22,0,102.53l95.53,95.53c36.41,36.52,36.38,95.64-.1,132.11l-170.85,170.85c-4.85,4.85-12.71,4.85-17.56,0l-114.13-114.13c-4.85-4.85-4.85-12.71,0-17.56l172.86-172.86c19.78-19.78,5.77-53.59-22.2-53.59H12.42c-6.86,0-12.42-5.56-12.42-12.42v-158.41c0-6.86,5.56-12.42,12.42-12.42Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2S);
export default __webpack_public_path__ + "static/media/2s.b8460e529a713a8659adae7be0de6c08.svg";
export { ForwardRef as ReactComponent };